const scoreboardColors = [
  "#FFFFFF", 
  "#000000", 
  "#000D9C", 
  "#FFF200", 
  "#662D91", 
  "#00A651", 
  "#DE0000", 
  "#DA3B99",
  "#F26522",
  "#00AEEF",
  "#888888",
  "#080059",
  "#CB9400",
  "#49022D"
];

export default scoreboardColors;